<template>
  <div class="header">
    <div class="top">
      <a href="/" class="logo"></a>
      <ul class="nav">
        <li
          :class="activeIndex == index ? 'active' : null"
          v-for="(item, index) in menuList"
          :key="index"
          @click="handleClickMenu(item)"
        >
          <a>{{ item.name }}</a>
        </li>
      </ul>
    </div>
    <div v-if="!user" class="login btn-right" @click="hanldeLoginShow('login')">
      登录
    </div>
    <div v-else class="register btn-right" @click="hanldeLoginOut">
      {{ user }},退出登陆
    </div>
    <div
      v-if="!user"
      class="register btn-right"
      @click="hanldeLoginShow('register')"
    >
      注册
    </div>
    <!-- <div class="pay btn-right" @click="handlJumpPay">充值</div> -->
    <my-login
      v-if="loginShow"
      @handleLogin="handleLogin"
      @handleCloseLogin="handleCloseLogin"
      :isRegister="isRegister"
    />
  </div>
</template>
 
<script>
import MyLogin from "./login/Login.vue";
export default {
  data() {
    return {
      menuList: [
        { path: "/mobile/index", name: "首页" },
        { path: "/mobile/game", name: "入驻游戏库" },
        { path: "/mobile/gift", name: "反馈中心" },
        { path: "/mobile/news", name: "联系我们" },
      ],
      loginShow: false,
      user: "",
      isRegister: false,
    };
  },
  mounted() {
    // if (this.$isMobile()) {
    //   require("../../../css/header-phone.min.css");
    // } else {
    //   require("../../../css/header.min.css");
    // }
  },
  components: {
    "my-login": MyLogin,
  },
  props: {
    activeIndex: {
      type: [String, Number],
      default() {
        return 0;
      },
    },
  },
  methods: {
    handlJumpPay() {
      this.$router.replace("/pay");
    },
    handleLogin(user) {
      this.loginShow = false;
      this.user = user;
    },
    hanldeLoginShow(item) {
      this.isRegister = item == "login" ? false : true;
      this.loginShow = true;
    },
    hanldeLoginOut() {
      this.user = "";
    },
    handleCloseLogin() {
      this.loginShow = false;
    },
    handleClickMenu(item) {
      this.$router.replace(item.path);
    },
  },
  // 组件逻辑
};
</script>
 
<style>
@import url(../../../css/header-phone.min.css);
</style>


// WEBPACK FOOTER //
// src/components/mobile/MyHeader.vue